<template>
  <div id="main-page">

     <v-dialog v-model="showGrade" max-width="900px" attach="#main-page" >
        <view-grade
            v-if="showGrade"
            :grade_id="selectedLead._id"
            @close-parent="showGrade=false"
        ></view-grade>
     </v-dialog>


     <v-dialog v-model="showViewCoachup" max-width="900px" attach="#main-page" >
        <view-coachup
            v-if="showViewCoachup"
            :coachup="selectedCoachup"
            @close-parent="showViewCoachup=false"
        ></view-coachup>
     </v-dialog>



     <!--<v-dialog v-model="editGrade" max-width="1200px" persistent >-->
     <!--   <div style="background-color: white">-->
     <!--      <div style="justify-content: flex-end; display: flex; margin-bottom: -20px">-->
     <!--         <v-btn icon @click="close_edit_dialog()">-->
     <!--            <v-icon>close</v-icon>-->
     <!--         </v-btn>-->
     <!--      </div>-->
     <!--      <edit-grade-->
     <!--          v-if=" editGrade"-->
     <!--          :grade_id="selectedLead._id"-->
     <!--          @close="close_edit_dialog()"-->

     <!--      />-->
     <!--   </div>-->

     <!--</v-dialog>-->





     <!--<v-dialog-->
     <!--    v-model="dialog_delete_grade"-->
     <!--    max-width="420"-->
     <!--&gt;-->
     <!--   <v-card>-->
     <!--      <v-card-title class="headline">Confirm Delete Grade?</v-card-title>-->

     <!--      <v-card-text>-->
     <!--         Are you sure you want to delete this graded lead?-->
     <!--      </v-card-text>-->

     <!--      <v-card-actions>-->
     <!--         <v-btn color="red" text @click="delete_graded_lead(del_grade_id)">Delete</v-btn>-->
     <!--         <v-spacer></v-spacer>-->
     <!--         <v-btn text @click="close_del_confirm">Cancel</v-btn>-->
     <!--      </v-card-actions>-->
     <!--   </v-card>-->
     <!--</v-dialog>-->







     <v-dialog v-model="editCoachup" max-width="1200px" persistent >
        <div style="background-color: white">
           <div style="justify-content: flex-end; display: flex; margin-bottom: -20px">
              <v-btn icon @click="close_edit_dialog()">
                 <v-icon>close</v-icon>
              </v-btn>
           </div>
           <grade-coach-up
               v-if=" editCoachup"
               :coachup_id="selectedCoachup._id"
               @close="close_edit_dialog()"

           />
        </div>

     </v-dialog>








    <section-definition title="Manager Teacher" >
    </section-definition>

    <v-container fluid grid-list-xl page>
      <v-layout row wrap>

         <v-flex class="ml-4" style="max-width: 150px">
            <v-autocomplete
                v-model="coachup_status"
                label="Coach Up Type"
                dense
                hide-details
                :items="['All', 'Active', 'Coached']"
                @change="on_change_top_inputs"
            />
         </v-flex>



        <v-flex grow></v-flex>



        <v-flex xs4 sm4 md2>
          <v-menu
              v-model="date_menu1"
              :close-on-content-click="false"
              :nudge-right="0"
              lazy
              transition="scale-transition"
              offset-y
              :nudge-bottom="0"
              full-width
              max-width="290px"
              min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                      v-model="selected_date_begin"
                      label="Begin Range"
                      hint="YYYY-MM-DD format"
                      prepend-icon="event"
                      v-on="on"
                      v-on:change="on_change_top_inputs"
              ></v-text-field>
            </template>
            <v-date-picker
                    v-model="selected_date_begin"
                    no-title
                    @input="date_menu1 = false"
                    v-on:change="on_change_top_inputs"
            ></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex xs4 sm4 md2>
          <v-menu
                  v-model="date_menu2"
                  :close-on-content-click="false"
                  :nudge-right="0"
                  lazy
                  transition="scale-transition"
                  offset-y
                  :nudge-bottom="0"
                  full-width
                  max-width="290px"
                  min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                      v-model="selected_date_end"
                      label="End Range"
                      hint="YYYY-MM-DD format"
                      prepend-icon="event"
                      v-on="on"

              ></v-text-field>
            </template>
            <v-date-picker
                    v-model="selected_date_end"
                    no-title
                    @input="date_menu2 = false"
                    v-on:change="on_select_dealership"
            ></v-date-picker>
          </v-menu>
        </v-flex>


         <v-flex xs12 sm4 md2>

            <v-autocomplete
                label="Organization"
                :items="orgs"
                item-value="_id"
                item-text="name"
                v-model="selected_org_id"
                v-on:change="on_org_change"
            >
            </v-autocomplete>

         </v-flex>


         <v-flex xs12 sm6 md3>

            <v-autocomplete
                label="Dealership"
                :items="dealerships"
                item-value="_id"
                item-text="name"
                v-model="selectedDealership"
                v-on:change="on_select_dealership"
                :clearable="clear_dealership"
            >
            </v-autocomplete>

         </v-flex>

        <!-- -->
        <!--<v-flex xs12 sm6 md4>-->

        <!--  <v-autocomplete-->
        <!--          label="Organization/Dealership"-->
        <!--          :items="dealerships"-->
        <!--          item-value="_id"-->
        <!--          item-text="txt"-->
        <!--          v-model="selectedDealership"-->
        <!--          v-on:change="on_select_dealership"-->
        <!--  >-->
        <!--  </v-autocomplete>-->

        <!--</v-flex>-->
      </v-layout>


      <v-container fluid grid-list-md page>
        <!--<v-layout>-->

        <!--  &lt;!&ndash;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;card for overall dealer grade&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;-->
        <!--  <v-flex xs12 sm4 v-if="!sp_mode">-->
        <!--    <v-card>-->
        <!--      <v-toolbar color="transparent" flat>-->
        <!--        <v-toolbar-title>{{overall_grade_card_txt}}</v-toolbar-title>-->
        <!--        &lt;!&ndash;<v-spacer></v-spacer>&ndash;&gt;-->
        <!--        &lt;!&ndash;<v-btn icon>&ndash;&gt;-->
        <!--          &lt;!&ndash;<v-icon>more_horiz</v-icon>&ndash;&gt;-->
        <!--        &lt;!&ndash;</v-btn>&ndash;&gt;-->
        <!--      </v-toolbar>-->
        <!--      &lt;!&ndash; <v-card-title primary-title class="title my-0">Visitors & Page views</v-card-title> &ndash;&gt;-->
        <!--      <v-card-text class="text-xs-center">-->
        <!--        <v-progress-circular-->
        <!--                :rotate="0"-->
        <!--                :value="100"-->
        <!--                :size="240"-->
        <!--                :width="15"-->
        <!--                :color="get_grade_color(gradeIxToLetter(grade_dealership.avg_grade_ix))"-->
        <!--        >-->
        <!--          <span class="grade-card"><strong>{{gradeIxToLetter(grade_dealership.avg_grade_ix)}}</strong> </span><br>-->
        <!--          <span class="grey&#45;&#45;text">Average Grade</span>-->
        <!--        </v-progress-circular>-->
        <!--        <div class="title my-2">Date Range</div>-->
        <!--        <span class="subheading grey&#45;&#45;text">{{selected_date_begin}} to {{selected_date_end}}</span>-->
        <!--      </v-card-text>-->
        <!--    </v-card>-->
        <!--  </v-flex>-->


        <!--  &lt;!&ndash;-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;card to list average grade of sales people-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;-->
        <!--  <v-flex xs12 sm8 v-if="!sp_mode">-->
        <!--    <v-card max-height="396px" style="overflow: auto">-->
        <!--      <v-toolbar color="transparent" flat>-->
        <!--        <v-toolbar-title>Sales Person Ranking</v-toolbar-title>-->
        <!--      </v-toolbar>-->
        <!--      &lt;!&ndash; <v-card-title primary-title class="title my-0">Visitors & Page views</v-card-title> &ndash;&gt;-->
        <!--      <v-card-text class="text-xs-left">-->

        <!--        <v-data-table-->
        <!--                :headers="sp_headers"-->
        <!--                :items="grades_salesPeople"-->
        <!--                :pagination.sync="sp_pagination"-->
        <!--                hide-actions-->



        <!--        >-->
        <!--          <template slot="items" slot-scope="props" >-->
        <!--            <tr-->
        <!--              class="row_style"-->
        <!--              style="cursor:pointer;"-->
        <!--              @click="on_select_salesPerson(props.item)"-->
        <!--              :key="props.item.user_id+props.item.dealership"-->
        <!--            >-->
        <!--              &lt;!&ndash;<td class="my-col">&ndash;&gt;-->
        <!--              &lt;!&ndash;  <v-avatar slot="activator" size="40">&ndash;&gt;-->
        <!--              &lt;!&ndash;    <img&ndash;&gt;-->
        <!--              &lt;!&ndash;        v-if="props.item.picture !== ''"&ndash;&gt;-->
        <!--              &lt;!&ndash;        :src="props.item.picture">&ndash;&gt;-->
        <!--              &lt;!&ndash;  </v-avatar>&ndash;&gt;-->
        <!--              &lt;!&ndash;</td>&ndash;&gt;-->
        <!--              <td class="my-col">{{ props.item.name }}</td>-->
        <!--               <td class="my-col">{{ props.item.dealership }}</td>-->
        <!--              <td class="my-col ">{{ get_val(props.item, 'curriculum.name', 'N/A')}}</td>-->
        <!--              <td class="my-col txt-center">{{ gradeIxToLetter(props.item.avg_grade_ix)}}</td>-->
        <!--              &lt;!&ndash;<td>{{ props.item.avg_score }}</td>&ndash;&gt;-->
        <!--              <td class="my-col txt-center">{{ props.item.count }}</td>-->
        <!--            </tr>-->
        <!--          </template>-->
        <!--        </v-data-table>-->
        <!--      </v-card-text>-->
        <!--    </v-card>-->
        <!--  </v-flex>-->





        <!--</v-layout>-->



        <!------------------------------list of individual coach ups ------------------------------------------------>
        <v-layout >
          <v-flex xs12>
            <v-card>
              <v-toolbar color="transparent" flat>
                <v-toolbar-title>Coach-Up Opportunities</v-toolbar-title>
                <v-spacer></v-spacer>

                 <v-btn small color="primary" @click="create_coachup">New Coach-Up</v-btn>

              </v-toolbar>
              <!-- <v-card-title primary-title class="title my-0">Visitors & Page views</v-card-title> -->
              <v-card-text class="text-xs-left">

                <v-data-table
                    :headers="gl_headers"
                    :items="coach_ups"
                    :pagination.sync="gl_pagination"
                >
                  <template slot="items" slot-scope="props" >
                     <!--v-on:click="view_this_grade(props.item)"  style="cursor:pointer;"-->
                    <!--<tr-->
                    <!--     :style="is_draft(props.item)? 'background-color:yellow':''"-->
                    <!--&gt;-->

                     <tr v-if="props.item.grade_id != null || props.item.manual_data != null">
                        <template v-if="props.item.grade_id != null">
                           <td  style="white-space: nowrap">{{ props.item.grade_id.date_graded.slice(0, 10) }}</td>
                           <td style="white-space: nowrap">{{ props.item.grade_id.grade_letter }}</td>
                           <td style="white-space: nowrap">{{ props.item.coachee.name }}</td>
                           <td style="">{{ props.item.grade_id.info_customer.name_first +' ' + props.item.grade_id.info_customer.name_last}}</td>
                           <td>{{ props.item.grade_id.info_lead.wanted_vehicle }}</td>
                           <td>{{ truncate_str(props.item.grade_id.comments_external) }}</td>
                        </template>

                        <template v-else-if="props.item.manual_data != null">
                           <td  style="white-space: nowrap">N/A</td>
                           <td style="white-space: nowrap">N/A</td>
                           <td style="white-space: nowrap">{{ props.item.coachee.name }}</td>
                           <td style="">{{ props.item.manual_data.info_lead.customer +' ' + props.item.manual_data.info_lead.customer}}</td>
                           <td>{{ props.item.manual_data.info_lead.vehicle }}</td>
                           <td>N/A</td>
                        </template>

                        <!--<template v-else>-->
                        <!--   <td>-->
                        <!--      {{JSON.stringify(props.item)}}-->
                        <!--   </td>-->
                        <!--</template>-->


                       <td>
                          <v-btn v-if="props.item.grade_id != null"
                              flat :color="!is_finished(props.item) ? 'accent': ''" small class="ma-0" @click="view_this_grade(props.item.grade_id)">
                            Review Grade
                          </v-btn>

                          <!--:to="'/coachup?coachup_id='+props.item._id"-->
                          <v-btn
                              v-if="!is_finished(props.item)"
                              flat color="accent" small class="ma-0"

                              @click="edit_this_coachup(props.item)"
                          >
                             Coach-Up
                          </v-btn>
                          <v-btn
                              v-else
                              flat  small class="ma-0"  @click="view_this_coachup(props.item)">
                             View Coachup
                          </v-btn>

                       </td>

                    </tr>
                  </template>
                </v-data-table>



                 <!--<div>-->

                 <!--   <div v-for="item in coach_ups" :key="item._id">-->
                 <!--      Coachee: {{item.coachee.name}}-->
                 <!--      Coach: {{item.coach.name}}-->
                 <!--      Date In: {{item.grade_id.info_lead.lead_arrived_date}}-->
                 <!--      Date Graded: {{ item.grade_id.date_graded.slice(0, 10) }}-->
                 <!--      Customer: {{ item.grade_id.info_customer.name_first +' ' + item.grade_id.info_customer.name_last}}-->
                 <!--      Vehicle: {{ item.grade_id.info_lead.wanted_vehicle }}-->
                 <!--      Grade: {{ item.grade_id.grade_letter }}-->

                 <!--      comments: {{ truncate_str(item.grade_id.comments_external) }}-->
                 <!--   </div>-->
                 <!--</div>-->





              </v-card-text>
              </v-card>

          </v-flex>

        </v-layout>







      </v-container> <!--main container-->
    </v-container>











  </div>
</template>


<style scoped>
  .grade-card{
    font-size: xx-large;
    font-weight: bolder;
    /*color: black;*/
  }

  .row_style{
    text-align: left;
    border: none !important;
    font-size: large;
  }

  .txt-center{
      text-align: center;
  }

 div >>> td{
      padding-left: 7px !important;
      padding-right: 7px !important;
  }

  div >>> th{
      padding-left: 7px !important;
      padding-right: 7px !important;
  }
</style>


<script>
   import axios from 'axios';
   const moment = require('moment');
   import viewGrade from '../components/viewGrade.vue';
   import editGrade from "@/views/Curricula/GradeLead";
   import GradeCoachUp from "@/views/Curricula/GradeCoachUp";
   import data_getters from '../mixins/data_getters';
   import _ from 'lodash';

   import {DateTime} from 'luxon';
   import ViewCoachup from "@/components/viewCoachup";

   // function findWithAttr(array, attr, value) {
   //    for(var i = 0; i < array.length; i += 1) {
   //       if(array[i][attr] === value) {
   //          return i;
   //       }
   //    }
   //    return -1;
   // }



export default {
      name: 'CoachUpQue',
   components:{
      ViewCoachup,
      viewGrade, GradeCoachUp
   },

   mixins: [data_getters],

  data() {
     return {
        letter_grades: ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D+', 'D', 'D-', 'F'],
        date_menu1: false,
        date_menu2: false,
        selected_date_begin:   moment().subtract(90, 'days').format('YYYY-MM-DD'),
        selected_date_end:   moment().format('YYYY-MM-DD'),
        show_finished: false, //controls if all coachup or just the non-finished ones are shown
        coachup_status: 'Active', //for status drop down in nav bar


        orgs: [],
        selected_org_id: null,

        dealerships: [],
        selectedDealership: null,
        salesPeople: [],
        selectedSalesPerson: null,

        // grade_dealership: {},
        // grades_salesPeople: [],
        // sp_graded_leads: [],

        coach_ups: [],


        selectedLead: null,
        showGrade: false,

        selectedCoachup: null,
        editCoachup: false,
        showViewCoachup: false,

        sp_headers: [
           // {text: '', value: 'picture', width: '5%'},
           {text: 'Sales Person', value: 'name',},
           {text: 'Dealership', value: 'dealership',},
           {text: 'Curriculum', value: 'curriculum.name', },
           {text: 'Avg Grade', value: 'avg_grade_ix', },
           // {text: 'Avg Score', value: 'avg_score', width: '20%'},
           {text: '# Leads', value: 'count', },
        ],

        sp_pagination: {
           sortBy: 'avg_grade_ix', // The field that you're sorting by
           descending: false,
           rowsPerPage: -1
        },




        gl_headers_non_admin: [
           // {text: 'Date In', value: 'grade_id.date_graded', },
           {text: 'Date Graded', value: 'grade_id.date_graded', },
           {text: 'Grade', value: 'grade_id.grade_letter_ix', },
           {text: 'Sales Person', value: 'coachee.name', },
           // {text: 'Score', value: 'grade_id.curriculum.name', },
           {text: 'Customer', value: 'grade_id.curriculum.name', },
           {text: 'Vehicle', value: 'grade_id.curriculum.name', },
           {text: 'Comments', value: 'grade_id.curriculum.name', },

           {text: '', value: '',},
        ],

        gl_headers_admin: [

           // {text: 'Date In', value: 'grade_id.date_graded', },
           {text: 'Date Graded', value: 'grade_id.date_graded', },
           {text: 'Grade', value: 'grade_id.grade_letter_ix', },
           {text: 'Sales Person', value: 'coachee.name', },
           // {text: 'Curriculum', value: 'grade_id.curriculum.name', },


           {text: 'Customer', value: 'grade_id.customer.name', },
           {text: 'Vehicle', value: 'grade_id.curriculum.name', },
           {text: 'Comments', value: 'grade_id.curriculum.name', },

           {text: '', value: '',},

        ],


        dialog_delete_grade: false,
        del_grade_id: null,


        gl_pagination: {
           sortBy: 'grade_id.grade_letter_ix', // The field that you're sorting by
           descending: true,
           rowsPerPage: -1
        },

        page: {
           title: "Report Card",
        },

     };
  },
  methods:{


     //simple function to tell if a grade is a draft or not.  needed since we added the date_email field on 3/1/2021
     is_draft(lead) {

        // console.log({lead})
        // if (DateTime.fromISO(lead.date_graded) < DateTime.fromISO('2021-02-23T00:00:00')) {
        //    return false;
        // }

        return  (lead.emailed_users === null);
        // {
        //    return 'background-color: #ffffff';
        // } // note this needs to be an exact match to handle the case of date_emailed not being defined
     },


     is_finished(coachup){
       return _.get(coachup, 'emailed_users.date', null) !== null;
     },

     get_val(obj, name, def=null){
        return _.get(obj, name, def)
     },


     async on_org_change(){
        this.selectedDealership = null;
        this.dealerships = await this.get_dealers({org_id: this.selected_org_id});
        if (this.dealerships.length > 0){
           this.selectedDealership = this.dealerships[0]._id;
        }
        await this.get_coachups_local();
     },




     async get_dealers_local(){


        try {
           // let {data} = await axios.get(url, token);
           this.dealerships = await this.get_dealers();

           for (let i=0; i<this.dealerships.length; i++){
              let d = this.dealerships[i];
              if (d.org_id){
                 this.dealerships[i].txt = d.org_id.name +' / '+d.name;
              }
              else{
                 this.dealerships[i].txt ='No Group/'+d.name;
              }
           }//for i

           this.dealerships = this.dealerships.sort((a, b) => (a.txt > b.txt) ? 1 : -1);


        }
        catch(err){
           console.log(err);
           // ans = err.response.data;
        }
     },



     on_change_top_inputs(){
       if (this.sp_mode){
          this.get_graded_leads_local(this.selectedSalesPerson.user_id)
       } else{
          this.on_select_dealership();
       }
     },


     async on_select_dealership(){


        console.log('debug')

        try{

           await this.get_coachups_local()

        }catch (e) {
           console.error(e);
        }



     },

     //
     // async on_select_salesPerson(sp){
     //    this.selectedSalesPerson = sp;
     //
     //    await this.get_graded_leads_local(sp.user_id)
     // },

     view_this_grade(grade){
        console.log('debug')
        this.selectedLead = grade;
        this.showGrade=true;


     },




     async delete_graded_lead( grade_id){
        console.log('grade', grade_id)
        let {token, query} = await this.base_user_request();
        let url = this.$baseUrlApi + '/deleteGradedLead';

        query.grade_id = grade_id;


        try {

           let res = await axios.post(url, {query }, token);
           this.dialog_delete_grade = false;
           this.del_grade_id = null;



           this.get_graded_leads_local(this.selectedSalesPerson.user_id).catch(e =>{
              console.error(e);
           })

        }
        catch(err){
           console.log(err);

        }
     },

     del_grade(grade){

        this.del_grade_id = grade._id;
        this.dialog_delete_grade = true;
     },

     close_del_confirm(){
        this.dialog_delete_grade = false;
        this.del_grade_id = null;
     },


     // async get_graded_leads_local(user_id){
     //
     //    if (user_id == null){
     //       user_id = this.selectedSalesPerson.user_id;
     //    }
     //
     //
     //    let dateRange = {begin: this.selected_date_begin, end: this.selected_date_end };
     //
     //    console.log('debug')
     //    try {
     //       this.sp_graded_leads = await this.get_graded_leads({user_id, dateRange,
     //          dealer_id: this.selectedDealership == null? undefined: this.selectedDealership,
     //          org_id: this.selected_org_id, get_player_data: 'percent'});
     //
     //
     //       console.log('i ran')
     //    }
     //    catch(err){
     //       console.log(err);
     //       // ans = err.response.data;
     //    }
     // },


     create_coachup(){
        this.editCoachup=true;
        this.selectedCoachup = {}
     },


     async get_coachups_local(){

        this.loading_team = true;
        console.log('get_coachups')

        // if (this.selectedDealership === undefined)
        //    return;


        let {token, query} = await this.base_user_request();
        let url = this.$baseUrlApi + '/getCoachups';


        query.status = this.coachup_status;


        let payload, payload2;
        if (this.selectedDealership){
           query.org_id = this.selected_org_id;
           query.dealer_id = this.selectedDealership;

           payload = {
              match: query,
              dateRange: {begin: this.selected_date_begin, end: this.selected_date_end },
              // groupby: 'dealership',
              // user_role: 'SalesPerson',
           };


        }


        else{
           delete query.dealer_id;
           query.org_id = this.selected_org_id;




           payload = {
              match: query,
              dateRange: {begin: this.selected_date_begin, end: this.selected_date_end },
              // groupby: 'organization',
              // user_role: 'SalesPerson',
           };

        }


        console.log({payload, payload2, query})



        try {
           if (this.selectedDealership || true){
              let {data} = await axios.post(url, payload, token);

              this.coach_ups = data;

              // if (data.length===1){
              //    this.grade_dealership = data[0];
              // }
              // else{
              //    this.grade_dealership = {avg_grade_ix: -1}
              // }
              //
              //


           }

        }
        catch(err){
           console.log(err);
           this.avg_grade_ix = -1;

        }

     },





     gradeIxToLetter(ix){
        if (ix>-1){
           return this.letter_grades[Math.round(ix)];
        }
        else{
           return 'N/A';
        }
     },

     get_grade_color(grade){
        let ans;
        switch (grade.charAt(0)){
           case 'A':
              ans =  '#00C853';
              break;
           case 'B':
              ans =  '#F9A825';
              break;
           case 'C':
              ans =  '#F9A825';
              break;
           case 'D':
              ans =  '#D50000';
              break;
           case 'F':
              ans =  '#D50000';
              break;
           case 'N':
              ans =  '#9E9E9E';
              break;

        }
        return ans;
     },

     edit_this_coachup(coachup){
        this.selectedCoachup = coachup;
        this.editCoachup = true;
     },

     view_this_coachup(coachup){
        this.selectedCoachup = coachup;
        this.showViewCoachup = true;
     },

     close_view_coachup_dialog(){
        this.editCoachup=false;
        this.selectedCoachup=null;
     },

     close_edit_dialog(){

        this.editCoachup=false;
        this.selectedCoachup=null;
        this.get_coachups_local();
     }



  },
   computed: {
     sp_mode(){
        return this.$auth.profile.user_role === 'SalesPerson';
     },

      clear_dealership(){
         let ans = true;
         let acct_type = this.$auth.profile.acct_type;
         let user_role = this.$auth.profile.user_role;

         if (acct_type === 'CLIENT' && ['Manager', 'SalesPerson'].includes(user_role)){
            ans = false;
         }

         console.log('debug clear_dealership', ans)
         return ans;
      },

      show_graded_leads(){
        if (this.$auth.profile.user_role !== 'SalesPerson'){
           return !!this.selectedSalesPerson;
        }
        else{
           return true;
        }

      },

      gl_headers(){

         // this.$auth.profile.user_role === 'Admin' &&
         if (this.$auth.profile.acct_type === 'AGENCY'){
            return this.gl_headers_admin;
         }
         else{
            return this.gl_headers_non_admin;
         }
      },

      overall_grade_card_txt(){
        if (this.selectedDealership == null){
           return 'Organization Grade';
        }
        else{
           return 'Dealership Grade';
        }
      },

      isAdmin(){
         return (this.$auth.profile.acct_type === 'AGENCY' && this.$auth.profile.user_role === 'Admin' )
      }

   },

  async created(){

      this.orgs = await this.get_organizations();


      if (this.orgs.length>0){
         this.selected_org_id = this.orgs[0]._id;
      }
     await this.on_org_change();



      // get url query parameters
      try{

         if (this.$route.query.coachup_id !== undefined) {
            let {headers, query} = await this.base_user_request();
            let url = this.$baseUrlApi + '/getCoachups';

            query._id = this.$route.query.coachup_id;
            let payload = {match: query};

            let {data} = await axios.post(url, payload, headers);

            console.log({data});

            if (data != null){
               this.selectedCoachup = data;

               if (data.emailed_users == null || data.emailed_users.date == null){
                  this.editCoachup = true;
               }
               else {
                  this.showViewCoachup = true;
               }
            }else{
               //give error message
            }

         }
      }
      catch (e) {
         console.error(e)
      }





  }
};
</script>
